import type { Modal } from 'hooks/useGlobalModal';
import { Link, NakedButton } from '@qga/roo-ui/components';
import { CONTACT_US_URL, CUSTOMER_SUPPORT_HOTLINE_AU, CUSTOMER_SUPPORT_HOTLINE_INTL } from 'config/constants';
import { expiredCreditCardModalLinkSelected } from 'lib/gaTracking/crossPageEvents';
import { openLiveChat } from 'lib/liveChat/actions';
import TelLink from 'components/TelLink';

const onClickLiveChat = () => {
  openLiveChat();
  expiredCreditCardModalLinkSelected('live chat');
};

export const contactUsModalProps: Modal = {
  variant: 'error',
  header: 'Your credit card has expired',
  body: (
    <>
      We were unable to process payment, and your changes have not been completed.
      <br />
      <br />
      To continue with your booking, please contact us via{' '}
      <Link as={NakedButton} onClick={onClickLiveChat} underline>
        live chat
      </Link>
      ,{' '}
      <Link target="_blank" href={`${CONTACT_US_URL}`} onClick={() => expiredCreditCardModalLinkSelected('email')} underline>
        email
      </Link>
      , or call{' '}
      <TelLink
        number={CUSTOMER_SUPPORT_HOTLINE_AU}
        color="greys.steel"
        underline
        onClick={() => expiredCreditCardModalLinkSelected('call customer support')}
      />{' '}
      (outside Australia:{' '}
      <TelLink
        number={CUSTOMER_SUPPORT_HOTLINE_INTL}
        color="greys.steel"
        underline
        onClick={() => expiredCreditCardModalLinkSelected('call international customer support')}
      />
      ).
    </>
  ),
  button: 'Close',
};
